var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-icon-button md-accent",on:{"click":function($event){return _vm.$emit('close')}}},[_c('md-icon',[_c('ri',{attrs:{"n":"close-circle-line"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }